//Fixing header on scroll
var $header = $('.header');
var $section = $('section');

if(
	checkWhitePage()
) {
	$header.addClass("js-static");
}

if ($section.hasClass('page-error')) {
	$header.addClass('js-error');
	$('html').css('overflow', 'hidden');
}

function fixedHeader(){
	if($(window).scrollTop() > 50){
		$header.addClass("js-fixed-header");
	}
	else {
		if ($(window).innerWidth() > 1200) {
			$header.removeClass("js-fixed-header");
		} else if (!checkWhitePage()){
			$header.removeClass("js-fixed-header js-static");
		}
	}
}

fixedHeader();
setNavHeight();

$(window).scroll(function() {
	fixedHeader();
	setNavHeight();
});

function setNavHeight() {
	if (window.innerWidth <= 768) {
		$('.js-nav').height(window.innerHeight);
	}
}

function checkWhitePage() {
	return $section.hasClass('page-events') ||
	$section.hasClass('partners-page') ||
	$section.hasClass('vacancies-page') ||
	$section.hasClass('contacts-page')
}

// burger menu logic
const navigation = $('.js-nav');

$('.header__burger').on('click', function () {
	if (!navigation.hasClass('js-enter')) {
		navigation.addClass('js-enter').removeClass('js-leave');
		$(this).addClass('js-open');
		$('html, body').css({'overflow': 'hidden'});
		$header.removeClass("js-fixed-header js-static");

		if(window.innerWidth < 481) {
			$('.js-fade').css({'opacity': 1});
		}

	} else if (!navigation.hasClass('js-leave')) {
		navigation.addClass('js-leave').removeClass('js-enter');
		$(this).removeClass('js-open');
		$('html, body').css({'overflow': ''});

		if($(window).scrollTop() > 50) {
			$header.addClass("js-fixed-header js-static");
		} else if (checkWhitePage()) {
			$header.addClass("js-static");
		}

		if(window.innerWidth < 481) {
			$('.js-fade').css({'opacity': 0});
		}
	}
});
